(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('shippingCalculator', () => ({
      country: 'United States',
      province: '',
      query: '',
      open: false,
      zip: '',
      rates: null,
      loading: false,
      error: '',

      states: [
        { name: 'Alabama' },
        { name: 'Alaska' },
        { name: 'Arizona' },
        { name: 'Arkansas' },
        { name: 'California' },
        { name: 'Colorado' },
        { name: 'Connecticut' },
        { name: 'Delaware' },
        { name: 'Florida' },
        { name: 'Georgia' },
        { name: 'Hawaii' },
        { name: 'Idaho' },
        { name: 'Illinois' },
        { name: 'Indiana' },
        { name: 'Iowa' },
        { name: 'Kansas' },
        { name: 'Kentucky' },
        { name: 'Louisiana' },
        { name: 'Maine' },
        { name: 'Maryland' },
        { name: 'Massachusetts' },
        { name: 'Michigan' },
        { name: 'Minnesota' },
        { name: 'Mississippi' },
        { name: 'Missouri' },
        { name: 'Montana' },
        { name: 'Nebraska' },
        { name: 'Nevada' },
        { name: 'New Hampshire' },
        { name: 'New Jersey' },
        { name: 'New Mexico' },
        { name: 'New York' },
        { name: 'North Carolina' },
        { name: 'North Dakota' },
        { name: 'Ohio' },
        { name: 'Oklahoma' },
        { name: 'Oregon' },
        { name: 'Pennsylvania' },
        { name: 'Rhode Island' },
        { name: 'South Carolina' },
        { name: 'South Dakota' },
        { name: 'Tennessee' },
        { name: 'Texas' },
        { name: 'Utah' },
        { name: 'Vermont' },
        { name: 'Virginia' },
        { name: 'Washington' },
        { name: 'West Virginia' },
        { name: 'Wisconsin' },
        { name: 'Wyoming' },
        { name: 'District of Columbia' },
      ],

      get filteredStates() {
        const q = (this.query || '').toLowerCase();
        return this.states.filter((s) => s.name.toLowerCase().includes(q));
      },

      selectState(s) {
        this.province = s.name;
        this.query = s.name;
        this.open = false;
      },

      get displayAddress() {
        return [this.zip, this.province, this.country].filter(Boolean).join(', ');
      },

      formatMoney(price) {
        const num = parseFloat(price);
        return '$' + num.toFixed(2);
      },

      buildQueryString() {
        const params = [
          'shipping_address[country]=' + encodeURIComponent(this.country),
          'shipping_address[zip]=' + encodeURIComponent(this.zip),
        ];
        if (this.province) {
          params.push('shipping_address[province]=' + encodeURIComponent(this.province));
        }
        return params.join('&');
      },

      async getRates() {
        if (!this.zip) return;

        this.loading = true;
        this.error = '';
        this.rates = null;

        try {
          const qs = this.buildQueryString();
          const root = window.Shopify?.routes?.root || '/';

          const res = await fetch(root + 'cart/shipping_rates.json?' + qs, {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!res.ok) {
            const errText = await res.text();
            console.error('[Shipping Calculator] failed:', res.status, errText);
            this.error = 'Could not retrieve shipping rates.';
            return;
          }

          const data = await res.json();
          this.rates = data.shipping_rates || [];
        } catch (err) {
          console.error('[Shipping Calculator] Error:', err);
          this.error = err.message;
        } finally {
          this.loading = false;
        }
      },

      reset() {
        this.rates = null;
        this.province = '';
        this.query = '';
        this.zip = '';
        this.error = '';
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

})();
